import { AnimatePresence, motion, useReducedMotion } from 'motion/react'
import { BarChart3, CreditCard, Ellipsis, Home, PieChart, Search, Settings, WalletCards } from 'lucide-react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { Brand } from '../components/Brand'
import { useAppState } from '../state/AppState'

const primary = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/portfolio', label: 'Portfolio', icon: PieChart, end: false },
  { to: '/markets', label: 'Markets', icon: BarChart3, end: false },
  { to: '/cards', label: 'Cards', icon: CreditCard, end: false },
  { to: '/more', label: 'More', icon: Ellipsis, end: false }
]

const secondary = [
  { to: '/payments', label: 'Payments', icon: WalletCards, end: false },
  { to: '/analytics', label: 'Analytics', icon: BarChart3, end: false },
  { to: '/activity', label: 'Activity', icon: Search, end: false },
  { to: '/settings', label: 'Settings', icon: Settings, end: false }
]

export function AppShell() {
  const location = useLocation(); const reduced = useReducedMotion(); const { toast } = useAppState()
  return <div className="app-frame">
    <aside className="desktop-nav"><Brand/><nav>{[...primary, ...secondary].map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end}><Icon size={20}/><span>{label}</span></NavLink>)}</nav><p>Finvia account<br/>Prices may be delayed.</p></aside>
    <main className="app-main"><AnimatePresence mode="wait"><motion.div key={location.pathname} className="route-view" initial={reduced ? false : { opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.18 }}><Outlet /></motion.div></AnimatePresence></main>
    <nav className="bottom-nav" aria-label="Primary navigation">{primary.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end}><Icon size={22} strokeWidth={1.8}/><span>{label}</span></NavLink>)}</nav>
    <AnimatePresence>{toast ? <motion.div className="toast" role="status" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 8 }}>{toast}</motion.div> : null}</AnimatePresence>
  </div>
}

